import { HttpInterceptorFn } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "../../auth/services/auth";

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (token) {
    const cloned = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
    return next(cloned);
  }

  return next(req);
};
